import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({name: 'safeHtml', pure: true})
export class SafeHtml implements PipeTransform {
  constructor(private sanitizer:DomSanitizer){}

  // tslint:disable-next-line:typedef
  transform(data: any, type: any) {
    // return this.sanitizer.bypassSecurityTrustStyle(html);
    if(type === 'html') {
      return this.sanitizer.bypassSecurityTrustHtml(data);
    }
    if(type === 'url') {
      return this.sanitizer.bypassSecurityTrustResourceUrl(data);
    }
    // return this.sanitizer.bypassSecurityTrustScript(html);
    // return this.sanitizer.bypassSecurityTrustUrl(html);
    // return this.sanitizer.bypassSecurityTrustResourceUrl(html);
  }
}